import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class MainService {
    public showLoader: boolean = false;

    public isDevelopment = environment.deploymentEnvironment !== 'production';

    public verifyParams: any = null;
    public verifiedHere = false;

    public init() {
        // noop
    }
}
